import { render, staticRenderFns } from "./singleProject.vue?vue&type=template&id=776e4a51&scoped=true"
import script from "./singleProject.vue?vue&type=script&lang=js"
export * from "./singleProject.vue?vue&type=script&lang=js"
import style0 from "./singleProject.vue?vue&type=style&index=0&id=776e4a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e4a51",
  null
  
)

export default component.exports